import * as React from "react"
import ProgressLoader from '../progress-loader'
import Toolbar, { ToolbarItem } from "../toolbar"
import { Profile, getProfile } from "../../domain/sfp/user-domain"
import { User } from "../../model"
import "./style.scss"

const forbiddenContent = <div className="section">
	<h2 className="title">Accès refusé</h2>
	<p>Vous n'avez pas les droits requis pour accéder à cette page.</p>
</div>

const loadingContent = <div className="section">
	Chargement...
</div>

export default
abstract class BasePage<TProps extends Props = Props, TState = {}>
extends React.Component<TProps, TState> {
	protected abstract editingProfiles: Profile[]
	protected abstract viewingProfiles: Profile[]
	protected abstract toolbar?: ToolbarItem[]
	protected abstract renderPageContent(): React.ReactNode

	render() {
		if (this.isLoading()) return <div className="section">
		Chargement...
		{/* {this.props.match && this.props.match.url && this.props.match.url.includes('rapport-de-gestion') && this.props.loaderStoreData !== null ? <ProgressLoader bgcolor="blue" completed={this.props.loaderStoreData}/>: null} */}
	</div>
		if (!this.props.currentUser) return forbiddenContent

		const profile = getProfile(this.props.currentUser)

		// if the user has one of the allowed profiles (editing or viewing)
		if (this.editingProfiles.some(p => p === profile)
		|| this.viewingProfiles.some(p => p === profile)) {
			return <div className="page">
				{this.toolbar &&
				<Toolbar items={this.toolbar} user={this.props.currentUser} />}

				<div className="page-content">
					{this.renderPageContent()}
				</div>
			</div>
		}

		return forbiddenContent
	}

	protected isLoading(): boolean {
		return this.props.loading
	}
}

export interface Props {
	currentUser: User
	loading: boolean
	loaderStoreData?: any
	match?: any
}



// WEBPACK FOOTER //
// ./src/component/base-page/index.tsx